<template>
  <div class="tool-tip" attach="body" @mouseleave="hideTooltip">
    <span class="tooltip" @mouseover="showTooltip($event, item)"
      ><slot>{{ defaultFormatter(item) }}</slot>
    </span>
    <!-- 툴팁내용 -->
    <teleport to="body">
      <div
        id="tooltip"
        class="tooltip-box"
        @mouseover="cancelHide"
        @mouseleave="hideTooltip"
      ></div>
    </teleport>
  </div>
</template>

<script>
import dc from "@/component/DataChk.js";
import { ref } from "vue";
export default {
  props: {
    item: {
      type: String,
      required: true,
    },
  },
  setup() {
    const tooltipX = ref(0);
    const tooltipY = ref(0);

    //methods 정의
    const showTooltip = (event, text) => {
      //툴팁 보이기
      const tooltip = document.getElementById("tooltip");
      tooltip.textContent = text;
      tooltip.style.opacity = "1";
      tooltip.style.display = "block";
      tooltipX.value = event.pageX + 50;
      tooltipY.value = event.pageY + 50;

      // 툴팁이 화면 아래로 넘어가지 않도록 위치 조정
      const windowHeight = window.innerHeight;
      const tooltipHeight = tooltip.offsetHeight; // 툴팁 높이 가져오기

      let topPosition = event.pageY - 20;

      // 툴팁이 화면 아래로 넘어가는 경우, 툴팁을 위로 올림
      if (topPosition + tooltipHeight > windowHeight) {
        topPosition = windowHeight - tooltipHeight - 20;
      }

      tooltip.style.left = event.pageX + 20 + "px"; //마우스 오른쪽 위치
      tooltip.style.top = event.pageY - 20 + "px"; //마우스 위쪽 위치
    };

    const hideTooltip = () => {
      const tooltip = document.getElementById("tooltip");
      tooltip.style.opacity = "0";
      tooltip.style.display = "none";
    };

    const cancelHide = () => {
      const tooltip = document.getElementById("tooltip");
      tooltip.style.opacity = "1";
      tooltip.style.display = "block"; // 요소 숨김 방지
    };

    // 기본 포멧
    const defaultFormatter = (value) => {
      return dc.nullChk(value) ? value : "-";
    };

    // html에서 사용될 데이터 정의
    return {
      tooltipX,
      tooltipY,
      showTooltip,
      cancelHide,
      hideTooltip,
      defaultFormatter,
    };
  },
};
</script>
